import { useContext, useState } from 'react';
import { OrderContext } from '../context/OrderContext';

const useRefundConfirmationEmail = () => {
  const { apiClient, uuid } = useContext(OrderContext);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  /**
   * İade onay mailini tetikler.
   * explicitUuid verilirse onu, verilmezse context'ten uuid'i kullanır.
   * options.dedupeKey verilirse kilit bu anahtara göre tutulur.
   */
  const sendConfirmationEmail = async (explicitUuid, options = {}) => {
    const { dedupeKey } = options;
    const effectiveUuid = explicitUuid || uuid;
    if (!effectiveUuid) {
      return;
    }

    // Aynı sayfa refresh edildiğinde veya React Strict Mode altında
    // effect iki kez çalıştığında tekrar mail gitmesini önlemek için
    const storageKey = dedupeKey
      ? `refundConfirmationEmailSent-${dedupeKey}`
      : `refundConfirmationEmailSent-${effectiveUuid}`;
    if (sessionStorage.getItem(storageKey)) {
      return;
    }
    // Kilidi ÖNCE koy, sonra isteği at. Böylece iki paralel çağrı olsa bile
    // sadece ilkinde request gider.
    sessionStorage.setItem(storageKey, '1');

    setLoading(true);
    setError(null);

    try {
      await apiClient.post(`api/v1/refund/${effectiveUuid}/send_confirmation_email/`, {});
    } catch (err) {
      const msg = err?.response?.data?.error || err.message || 'API error';
      setError(msg);
      // Eğer hata aldıysak kilidi kaldır ki kullanıcı yeniden deneyebilsin
      sessionStorage.removeItem(storageKey);
    } finally {
      setLoading(false);
    }
  };

  return { sendConfirmationEmail, loading, error };
};

export default useRefundConfirmationEmail;


